import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {TrueGrit} from "../../TrueGrit";
import {gsap, TimelineMax} from "gsap";
import {TrueGritSymbol} from "../../reels/TrueGritSymbol";
import {TrueGritGameMode} from "../../server/TrueGritGameMode";
import {TrueGritSound} from "../../sound/TrueGritSound";

/**
 * Created by Jerker Nord on 2021-07-15.
 */

export class TrueGritTopReelTransformRunner implements SimplePresentation {

    shouldRun():boolean {
        return TrueGrit.model.gameData.topTrain.transformSpellActivated.includes(true);
    }

    private complete(controller:SimplePresentationRunnerController):void {
        controller.finish();
    }

    private timeline:gsap.core.Timeline;

    start(controller:SimplePresentationRunnerController):void {
        const mainTL:TimelineMax = gsap.timeline({onComplete : () => this.complete(controller)});
        const subTransformSymbolsTLs:gsap.core.Timeline[] = [];
        let wildTransformSoundPlayed:boolean = false;
        let wildTransformNoWinSoundPlayed:boolean = false;
        for(let i:number = 0; i < TrueGrit.model.gameData.topTrain.transformSpellActivated.length; i++) {
            if(TrueGrit.model.gameData.topTrain.transformSpellActivated[i]) {
                const symbol:TrueGritSymbol = <TrueGritSymbol>TrueGrit.allReelsView.topReelModel.getSymbolBySymbolPosition(i);
                subTransformSymbolsTLs.push();
                let transformSymbolsTL:gsap.core.Timeline;
                const transformPositions:boolean[][] = TrueGrit.model.topTrain.transformSpellTransform;
                for(let i:number = 0; i < transformPositions.length; i++) {
                    for(let j:number = 1; j < transformPositions[i].length; j++) {
                        if(transformPositions[i][j]) {
                            let transformSymbol:TrueGritSymbol;
                            let transFormSymbolPosition:PIXI.Point;
                            let transformSymbolName:string;
                            let transformSymbolSplitLevel:number;
                            if(j == 4 && i > 1 && i < 5) {
                                transFormSymbolPosition = (<TrueGritSymbol>TrueGrit.allReelsView.bottomReelModel.getSymbolBySymbolPosition(i - 1)).position;
                                transformSymbolName = (<TrueGritSymbol>TrueGrit.allReelsView.bottomReelModel.getSymbolBySymbolPosition(i - 1)).symbolName;
                                transformSymbolSplitLevel = (<TrueGritSymbol>TrueGrit.allReelsView.bottomReelModel.getSymbolBySymbolPosition(i - 1)).splitLevel;
                            } else {
                                transFormSymbolPosition = (<TrueGritSymbol>TrueGrit.allReelsView.mainReelModels[i].reelView.getSymbol(j)).position;
                                transformSymbolName = (<TrueGritSymbol>TrueGrit.allReelsView.mainReelModels[i].reelView.getSymbol(j)).symbolName;
                                transformSymbolSplitLevel = (<TrueGritSymbol>TrueGrit.allReelsView.mainReelModels[i].reelView.getSymbol(j)).splitLevel;
                            }

                            transformSymbolsTL = gsap.timeline();
                            transformSymbolsTL.add(() => {
                                if(j == 4 && i > 1 && i < 5) {
                                    transformSymbol = (<TrueGritSymbol>TrueGrit.allReelsView.bottomReelModel.getSymbolBySymbolPosition(i - 1));
                                } else {
                                    transformSymbol = (<TrueGritSymbol>TrueGrit.allReelsView.mainReelModels[i].reelView.getSymbol(j));
                                }
                                if(transformSymbolSplitLevel < 2) {
                                    transformSymbol.visible = false;
                                }
                            });
                            if(TrueGrit.model.gameData.nextMode == TrueGritGameMode.NORMAL_AVALANCHE || TrueGrit.model.gameData.nextMode == TrueGritGameMode.FREESPIN_AVALANCHE) {
                                transformSymbolsTL.add(TrueGrit.wildTransformView.getWildTransformAnimation(transformSymbolSplitLevel, transformSymbolName, i, j, transFormSymbolPosition, false));
                            } else {
                                transformSymbolsTL.add(TrueGrit.wildTransformView.getWildTransformAnimation(transformSymbolSplitLevel, transformSymbolName, i, j, transFormSymbolPosition, true));
                            }

                            if(transformSymbolSplitLevel > 1) {
                                transformSymbolsTL.add(() => {
                                    transformSymbol.wasTransformed = true;
                                    transformSymbol.transformed = true;
                                    transformSymbol.resetPosition();
                                    transformSymbol.setCurrentStateSpriteTexture();
                                    transformSymbol.alpha = 0;
                                    transformSymbol.visible = true;
                                }, "-=0.2");
                                transformSymbolsTL.add(() => {
                                    gsap.to(transformSymbol, {
                                        duration : 0.2,
                                        alpha : 1
                                    })
                                }, "-=0.2");
                            } else {
                                transformSymbolsTL.add(() => {
                                    transformSymbol.wasTransformed = true;
                                    transformSymbol.transformed = true;
                                    transformSymbol.resetPosition();
                                    transformSymbol.setCurrentStateSpriteTexture();
                                    transformSymbol.visible = true;
                                });
                            }

                            subTransformSymbolsTLs.push(transformSymbolsTL);
                        }
                    }
                }
                transformSymbolsTL = gsap.timeline();
                transformSymbolsTL.add(() => {symbol.visible = false});
                if(TrueGrit.model.gameData.nextMode == TrueGritGameMode.NORMAL_AVALANCHE || TrueGrit.model.gameData.nextMode == TrueGritGameMode.FREESPIN_AVALANCHE) {
                    transformSymbolsTL.add([
                        TrueGrit.wildTransformView.getWildTransformAnimation(TrueGrit.allReelsView.topReelModel.getSymbolBySymbolPosition(i).splitLevel, TrueGrit.allReelsView.topReelModel.getSymbolBySymbolPosition(i).symbolName, i, 0, TrueGrit.allReelsView.topReelModel.getSymbolBySymbolPosition(i).position, false),
                        () => {
                            if(!wildTransformSoundPlayed) {
                                wildTransformSoundPlayed = true;
                                TrueGrit.soundPlayer.playSound(TrueGritSound.WILD_TRANSFORM_SOUND)
                            }
                        }
                    ]);
                } else {
                    transformSymbolsTL.add([
                        TrueGrit.wildTransformView.getWildTransformAnimation(TrueGrit.allReelsView.topReelModel.getSymbolBySymbolPosition(i).splitLevel, TrueGrit.allReelsView.topReelModel.getSymbolBySymbolPosition(i).symbolName, i, 0, TrueGrit.allReelsView.topReelModel.getSymbolBySymbolPosition(i).position, true),
                        () => {
                            if(!wildTransformNoWinSoundPlayed) {
                                wildTransformNoWinSoundPlayed = true;
                                TrueGrit.soundPlayer.playSound(TrueGritSound.WILD_TRANSFORM_NO_WIN_SOUND)
                            }
                        }
                    ]);
                }
                transformSymbolsTL.add(() => {
                    symbol.wasTransformed = true;
                    symbol.transformed = true;
                    symbol.resetPosition();
                    symbol.setCurrentStateSpriteTexture();
                    symbol.visible = true;
                });
                subTransformSymbolsTLs.push(transformSymbolsTL);
            }
        }
        mainTL.add(subTransformSymbolsTLs);

        if(mainTL.duration() == 0) {
            mainTL.add(gsap.to(this, {duration : 0.001}));
        }
    }
}